import { of as observableOf, Observable, Subscriber } from 'rxjs';
import { Injectable } from '@angular/core';
import { IReceivingService } from './Receiving.interface'
import { HttpParams } from '@angular/common/http';
import { APIENDPOINTURL } from '../configuration';
import {
  GetReceivingParamsDetaildById,
  PoSummary,
  PodetailModel,
  GetInventoryLookUp,
  SupplierListModel,
  LocationPayload,
  MerchandiseArrivalEntity,
  ReceivingPostModel
} from '../../models';
import { ConfigurationService } from '../configuration.service';
import { HttpRequestService } from 'src/app/shared/services/http-request.service';
import { apiURLs } from 'src/app/shared/globalcontants';
import { InventoryLookupCollection, InventoryLookUpPost, LookupConfigurationV2, SupplierItemLookUpPost } from 'src/app/shared/models/Inventory/InventoryLookUpEntity';
import moment from 'moment-timezone';

@Injectable({
  providedIn: 'root'
})
export class ReceivingService implements  IReceivingService {
    constructor(private httpService: HttpRequestService, private configurationService: ConfigurationService) { }
    GetInvoice(requestParams?: any): Observable <any> {
        const requestUrl =  apiURLs.TransactionManagement.GetReceiving + requestParams;
        return this.httpService.GetHttpRequest(requestUrl);
    }
    /**
     * @version 13.2 UI
     * @param getInvoiceDetailsById 
     * @returns 
     */

    GetInvoiceDetails(getInvoiceDetailsById: GetReceivingParamsDetaildById): Observable <any> {
      const GetInvoceRequest = `${apiURLs.TransactionManagement.GetReceivingDetailById}` + `?Id=${getInvoiceDetailsById.Id}&` + `IsApVoucher=${false}&` + `IsPPV=${false}`;
      return this.httpService.GetHttpRequest(GetInvoceRequest);
  }

  GetPOSummary(PoSummaryModel: PoSummary): Observable <any> {
    let inputParams = new HttpParams()
    if (PoSummaryModel.siteId != null){
      inputParams = inputParams.set('siteId', PoSummaryModel.siteId.toString());
    }
    return this.httpService.GetHttpRequestId(inputParams, APIENDPOINTURL.ReceivingApi.GetPOSummary);
  }

  /**
   * @version UI 13
   * @param PoSummaryModel 
   * @returns 
   */

  GetPurchaseOrderSummary(PoSummaryModel: any): Observable <any> {
    const PurchaserOrderHead = apiURLs.TransactionManagement.GetPurchaseOrderHeadSummary + PoSummaryModel;
    return this.httpService.GetHttpRequest(PurchaserOrderHead);
  }
/**
 * @
 * @param GetPoDetails 
 * @returns 
 */
 PoDetails(lookupModel: PodetailModel): Observable <any> {
  const requestUrl = `${apiURLs.TransactionManagement.GetPurchaseOrderById}`  + `?TransId=${lookupModel.PONumber}&` + `TranstypeId=${3}`;  
  return this.httpService.GetHttpRequest(requestUrl);
}
GetPoDetails(lookupModel: PodetailModel): Observable <any> {
  let inputParams = new HttpParams();
  if (lookupModel.siteId != null){
    inputParams = inputParams.set('siteId', lookupModel.siteId.toString());
  }
  inputParams = inputParams.set('PONumber', lookupModel.PONumber.toString());
  return this.httpService.GetHttpRequestId(inputParams, APIENDPOINTURL.ReceivingApi.GetPoDetails);
}
GetInventoryLookup(getInventoryLookUp: InventoryLookUpPost): Observable <InventoryLookupCollection> {
  return this.httpService.postHttpRequest(apiURLs.InvertoryManagement.GetInventoryLookup, getInventoryLookUp);
}

GetInventoryLookupV2(getInventoryLookUp: LookupConfigurationV2): Observable <InventoryLookupCollection> {
  return this.httpService.postHttpRequest(apiURLs.InvertoryManagement.GetInventoryLookupV2, getInventoryLookUp);
}
SearchBySupplierItemNumber (LookupModel: SupplierItemLookUpPost): Observable<any> {
  return this.httpService.postHttpRequest(apiURLs.InvertoryManagement.SearchBySupplierItemNumber, LookupModel);
}

GetSupplierList(requestParams: any): Observable <any> {
  try {
    if (requestParams) {
      const requestUrl =  apiURLs.InventoryAPI.GetSuppliers + requestParams;
      return this.httpService.GetHttpRequest(requestUrl);
    }
  } catch (error) {
      console.log('Error occured', error);
  }
}

GetPayTermById(payTermId: number): Observable<any> {
  const requestUrl = `/inventory/api/PayTerms?$filter=IsActive eq true and Id eq ${payTermId}`;
  return this.httpService.GetHttpRequest(requestUrl);
}

GetLocation(LocationParams: any): Observable <any> {
  try {
    if ( LocationParams) {
      const requestUrl =  apiURLs.InvertoryManagement.GetInventoryLocation + LocationParams;
      return this.httpService.GetHttpRequest(requestUrl);
    }
  } catch (error) {
      console.log('Error occured', error);
  }
}
PostReceivingMA(merchandiseArrivalEntity: ReceivingPostModel): Observable <any> {
  if (merchandiseArrivalEntity?.PostModel?.PostDate) {
    merchandiseArrivalEntity.PostModel.PostDate = moment(merchandiseArrivalEntity?.PostModel?.PostDate).startOf('day').format();
  }
  if( merchandiseArrivalEntity.enablePutMethod && merchandiseArrivalEntity.receivingId != 0){
    return this.httpService.putHttpRequest(apiURLs.TransactionManagement.GetReceiving + '/' + merchandiseArrivalEntity.receivingId, merchandiseArrivalEntity.PostModel);
  } else {
    return this.httpService.postHttpRequest(apiURLs.TransactionManagement.GetReceiving, merchandiseArrivalEntity.PostModel);

  }
}

SaveReceivingMA(merchandiseArrivalEntity: ReceivingPostModel): Observable <any> {
  if (merchandiseArrivalEntity?.PostModel?.PostDate) {
    merchandiseArrivalEntity.PostModel.PostDate = moment(merchandiseArrivalEntity?.PostModel?.PostDate).startOf('day').format();
  }
  if( merchandiseArrivalEntity.enablePutMethod && merchandiseArrivalEntity.receivingId != 0){
    return this.httpService.putHttpRequest(apiURLs.TransactionManagement.GetReceiving + '/' + merchandiseArrivalEntity.receivingId, merchandiseArrivalEntity.PostModel);
  } else {
    return this.httpService.postHttpRequest(apiURLs.TransactionManagement.GetReceiving, merchandiseArrivalEntity.PostModel);
  }
}

GetMiscCharges() {
  return this.httpService.GetHttpRequest(apiURLs.TransactionManagement.GetMiscCharges);
}

GetDMIntegrationConfiguration() {
  return this.httpService.GetHttpRequest(apiURLs.TransactionManagement.GetDMIntegrationConfiguration);
}

GetAllOCRProcess(Payload: any): Observable<any> {
      const requestUrl = apiURLs.TransactionManagement.GetAllOCRProcess;
      return this.httpService.postHttpRequest(requestUrl, Payload);
    }

DownloadInvoice(params: any): Observable<any> {
  const requestUrl = apiURLs.TransactionManagement.DownloadInvoice + '?id='+params.Id;
  return this.httpService.GethttpPDFMethod(requestUrl, {observe: 'response', responseType: 'blob'});
}

UploadInvoice(Payload: any): Observable<any> {
      const requestUrl = apiURLs.TransactionManagement.UploadInvoice;
      return this.httpService.postHttpRequestFormData(requestUrl, Payload);
  }

}